import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { firebaseConfig } from "../constants/firebase";

export function useDB() {
    return getFirestore(initializeApp(firebaseConfig));
}